$(document).ready(function () {
    $('.heroSlider').slick({
        dots: true,
        arrows: false,
        infinite: false,
        autoplaySpeed: 5000,
        speed: 2000,
        touchMove: true,
        fade: false,
        slidesToScroll: 1,
        autoplay: true,
        slidesToShow: 1,
        pauseOnHover: false
    });

    $('.testimonialSlider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplaySpeed: 5000,
        speed: 2000,
        touchMove: true,
        fade: false,
        slidesToScroll: 1,
        autoplay: true,
        slidesToShow: 3,
        pauseOnHover: false,
        responsive: [
                           {
                              breakpoint: 991,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                              }
                            },
                            {
                              breakpoint: 767,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                              }
                            },
                            {
                              breakpoint: 678,
                               settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                              }
                            }

                          ]
    });
    $('.product_images_container').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplaySpeed: 5000,
        speed: 500,
        touchMove: true,
        fade: false,
        slidesToScroll: 1,
        autoplay: false,
        slidesToShow: 1,
        pauseOnHover: false
    });
    console.log("ready!");

    $(".featured-products .product").mouseover(function () {
        $(".featured-products .product").removeClass("active");
    });
  
  $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active-ols');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  $(".product-single__thumbnail-image").click(function(){
  	var imageindex = $(this).attr("data-big-image-index");
    $('.product_images_container').slick('slickGoTo', imageindex);
  });
  $('input[name="quantity"]').blur(function(){
    if( !$(this).val() ){
  	$(this).val(1);
    }
  });
  // This button will increment the value
    $('.qtyplus').click(function(e){
        e.preventDefault();
        var fieldName = $(this).attr('field');
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        if (!isNaN(currentVal)) {
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            $('input[name='+fieldName+']').val(0);
        }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        e.preventDefault();
        var fieldName = $(this).attr('field');
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        if (!isNaN(currentVal) && currentVal > 1) {
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            $('input[name='+fieldName+']').val(1);
        }
    });
 
 
      $('#nav-icon1').click(function(){
          $(this).toggleClass('open');
          $("#desktop-menu").toggleClass("menu-open");
      });
	
      $(".ss-test-menu li a").click(function(e) {
        var divinfo=$(this).attr("href");
        $('html, body').animate({
          scrollTop: $(""+divinfo).offset().top-100
        }, 2000);
      });
//   	   $.ajax({
//                 type: 'PUT',
//                 url: '/admin/blogs/16291070011.json',
//                 dataType: 'json',
//                 data: { "title": "IPod Updates"}
//             });
      setTimeout(function(){
        $("body").css("opacity","1");
      },1000);
});

